

store.filters = {};
store.filters.init = function() {
	var $f = $('#storeFilters').find('form');
	if ($f.hasClass('inited')) {
		return;
	}
	$f.find('.storeSlider').each(store.filters.slider);
	$f.find('.filter.Radio').each(store.filters.radio);
	store.form.autoChange($f, 'storeSelector');
	store.form.ajax($f, {
		'.categoryProducts': '#store .category .categoryProducts',
		'#storeFilters': '#storeFilters'
	}, function() {
		store.filters.init();
		store.local.onCategoryProductsUpdate();
		store.local.onFilterUpdate();
	});
	$f.addClass('inited');
};
store.filters.radio = function () {
	store.makeRadioGroupDeselectable(this);
};
store.filters.slider = function() {
	var $t = $(this);
	var rel = $t.attr('rel');
	var t = rel.split('-');
	if (t.length === 2) {
		var min = parseInt(t[0]);
		var max = parseInt(t[1]);
		var $input = $t.parent().find('input.hidden');
		// Hide the nonJS options
		$t.parent().find('.options').hide();
		var current = $input.val();
		var values = (current.match(/-/)) ? current.split('-') : [min, max];
		var step = Math.ceil(max*0.05);

		$t.slider({
			range: true,
			min: min,
			max: max,
			values: values,
			step: step,
			slide: function(event, ui) {
				store.filters.sliderChange($t, ui.values);
			},
			change: function() {
				$input.trigger('change');
			}
		});
		store.filters.sliderChange($t, values);
	}
};
store.filters.sliderChange = function($slider, values) {
	var min = parseInt(values[0]);
	var max = parseInt(values[1]);
	var $input = $slider.parent().find('.hidden');
	var sliderMin = $slider.slider('option', 'min');
	var sliderMax = $slider.slider('option', 'max');
	if (sliderMin === min && sliderMax === max) {
		$input.val('');
	}
	else {
		$input.val(min + "-" + max);
	}
	var $label = $slider.parent().find('.label');
	if ($input.hasClass('price')) {
		$label.html(store.price.format(min) + " - " + store.price.format(max));
	}
	else {
		var format = $input.attr('rel') || '%value%';
		$label.html(store.filters.format(min, format) + " - " + store.filters.format(max, format));
	}
};
store.filters.format = function(value, format) {
	return format.replace('%value%', value);
};
